import {
  Button,
  Col,
  Descriptions,
  Input,
  Modal,
  Row,
  Space,
  Table,
} from 'antd';
import { Dropdown, InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import Excel from 'components/table/excel';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';
import ModalConfermWorker from 'components/tabel/tabelWorker/ModalConfermWorker';

export default function VIPWorkers() {
  const { urldashboard, authentication, accessPage } =
    useContext(DashboardContext);

  // table data
  const [data, setData] = useState([]);
  const [record, setRecord] = useState({});
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [moreInfoModal, setMoreInfoModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  useEffect(() => {
    if (!moreInfoModal && !confirmModal) {
      getVIPWorkers({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
      });
      setRecord({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moreInfoModal, confirmModal]);

  const getVIPWorkers = async ({ page, pageSize, searchValue }) => {
    setLoading(true);
    try {
      let url = '/workerVip/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, search: searchValue }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getVIPWorkers({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
    });
  };

  const search = () => {
    getVIPWorkers({
      page: 1,
      pageSize: 10,
      searchValue,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Dropdown>
          <Dropdown.Toggle
            style={{ backgroundColor: '#464dee', color: '#ffffff' }}
          ></Dropdown.Toggle>

          <Dropdown.Menu id={record?.id} align={'right'}>
            {accessPage?.includes('Confirm') && (
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => handleConfirm(record)}
              >
                تایید نیرو
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
    {
      title: 'نام',
      dataIndex: 'firstName',
      key: 'firstName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نام خانوادگی',
      dataIndex: 'lastName',
      key: 'lastName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'کد پرسنلی',
      dataIndex: 'personnelCode',
      key: 'personnelCode',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'خوابگاه',
      dataIndex: 'dormName',
      key: 'dormName',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'گروه اصلی',
      dataIndex: 'categoryTitle',
      key: 'categoryTitle',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تلفن ثابت',
      dataIndex: 'tell',
      key: 'tell',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تلفن همراه',
      dataIndex: 'cellPhone',
      key: 'cellPhone',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'معرف',
      dataIndex: 'referrerTitle',
      key: 'referrerTitle',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'کد ملی',
      dataIndex: 'nationalCode',
      key: 'nationalCode',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'وضعیت',
      dataIndex: 'isActive',
      key: 'isActive',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'اطلاعات بیشتر',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  // actions

  const showInfoModal = (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  const handleConfirm = (data) => {
    setRecord(data);
    setConfirmModal(true);
  };

  return (
    <>
      <Row
        gutter={20}
        style={{
          marginTop: 25,
        }}
      >
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <InputGroup>
            <Input
              placeholder='جستجوی سریع'
              name='searchValue'
              onChange={(e) => setSearchValue(e.target.value)}
              style={{
                height: '3rem',
                width: '90%',
                display: 'table-cell',
              }}
            />
            <Button
              onClick={search}
              style={{
                height: '3rem',
                width: '10%',
                display: 'table-cell',
                padding: 0,
              }}
            >
              <i className='mdi mdi-magnify'></i>
            </Button>
          </InputGroup>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Excel data={data} headers={headers} fileName={'سفارشات'} />
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={() => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      {confirmModal && (
        <ModalConfermWorker
          show={confirmModal}
          id={record.id}
          //   urldata={urldata}
          name={`${record?.firstName} 
                   ${record?.lastName}`}
          handelClose={() => setConfirmModal(false)}
          //   upDatae={handeldeleteitem}
        />
      )}

      <Modal
        title='اطلاعات بیشتر'
        closable={false}
        open={moreInfoModal}
        onCancel={() => setMoreInfoModal(false)}
        footer={[
          <Button key='back' onClick={() => setMoreInfoModal(false)}>
            بستن
          </Button>,
        ]}
        bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
      >
        <Descriptions bordered column={1} size={'small'}>
          <Descriptions.Item label='نام'>
            {record?.firstName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='نام خانوادگی'>
            {record?.lastName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='کد پرسنلی'>
            {record?.personnelCode ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='کد ملی'>
            {record?.nationalCode ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='گروه اصلی'>
            {record?.categoryTitle ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='خوابگاه'>
            {record?.dormName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تلفن ثابت'>
            {record?.tell ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تلفن همراه'>
            {record?.cellPhone ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ تولد'>
            {record?.persainBirthDate
              ? record?.persainBirthDate
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='معرف'>
            {record?.referrerTitle ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='فعال است؟'>
            {record?.isActive ? (
              <i
                className='mdi mdi-check'
                style={{ color: 'green', fontSize: '1.5rem' }}
              ></i>
            ) : (
              <i
                className='mdi mdi-close'
                style={{ color: 'red', fontSize: '1.5rem' }}
              ></i>
            )}
          </Descriptions.Item>
          <Descriptions.Item label='شهر محل سکونت'>
            {record?.cityName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='شماره کارت بانکی'>
            {record?.debitCardNumber ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ آخرین غیرفعال بودن'>
            {record?.persianInactiveDate
              ? record?.persianInactiveDate
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='پورسانت (درصد)'>
            {`${record?.commission}%`}
          </Descriptions.Item>
          <Descriptions.Item label='پورسانت اضافه‌کاری (درصد)'>
            {`${record?.overTimeCommission}%`}
          </Descriptions.Item>
          <Descriptions.Item label='ضمانت (ریال)'>
            {record?.warrantyAmount}
          </Descriptions.Item>
          <Descriptions.Item label='نوع نیرو'>
            {record?.workerTypeTitle ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='نوع سیستم‌عامل موبایل'>
            {record?.mobileTypeTitle ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='آیا در لیست سیاه مالی است؟'>
            {record?.isBlackListed ? 'بله' : 'خیر'}
          </Descriptions.Item>
          <Descriptions.Item label='آیا در لیست سیاه انضباطی است؟'>
            {record?.hasDiscipline ? 'بله' : 'خیر'}
          </Descriptions.Item>
          <Descriptions.Item label='آیا نیروی VIP است؟'>
            {record?.isVip ? 'بله' : 'خیر'}
          </Descriptions.Item>
          <Descriptions.Item label='آیا اپلیکیشن فعال است؟'>
            {record?.isReady ? 'بله' : 'خیر'}
          </Descriptions.Item>
          <Descriptions.Item label='امتیاز'>
            {record?.showPoints}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </>
  );
}
